<template>
  <div class="h-full">
    <div v-if="isLoading" class="shimmer h-[90px] w-full rounded-2xl" />
    <button
      v-else
      class="flex h-full w-full flex-col items-start gap-2 p-3"
      :class="customButtonClasses"
      @click="$emit('onButtonAction')"
    >
      <slot name="icon" />
      <span
        class="text-left text-[13px] font-medium leading-[18px]"
        :class="classes?.label"
        >{{ label }}</span
      >
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    label: string;
    classes?: {
      label?: string;
      button?: string;
    };
    isLoading: boolean;
  }>();

  defineEmits<{
    onButtonAction: [];
  }>();

  const customButtonClasses = computed(() => {
    return (
      props?.classes?.button || 'rounded-2xl bg-background-neutral-secondary'
    );
  });
</script>

<style scoped>
  .cashback-light-gradient {
    background:
      linear-gradient(
        260deg,
        rgba(1, 212, 138, 0.15) 1.12%,
        rgba(0, 111, 194, 0.15) 101.31%
      ),
      white;
  }

  .cashback-dark-gradient {
    background: linear-gradient(90deg, #243144, #1e2e35, #1b2e2a, #313c25);
  }

  .cashback-gradient-text {
    background: linear-gradient(
      251deg,
      rgb(1, 212, 138) 1.12%,
      rgb(0, 111, 194) 101.31%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
</style>
